<div class="modal-header">
  <h3 class="modal-title">Sourcing Default By Parent ME</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="modalClose()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

@if (!minimise) {
<div class="modal-body">
  <div class="panel-body">

    @if (acctType == '5' || acctType == '6') {
<div>
      <div class="field-label">
        <span>Basket Name</span>
      </div>
      <div class="SourcingDropdown">
        <ap-dropdown class="field-full-width" [list]="basketIdListView" [selectType]="'single'"
                    [title]="'Basket Name'" [hideTitleOnInput]="true" [inputAriaLabel]="'Basket Name'"
                    [(ngModel)]="selectedBasketItem"
                    (onSelect)="onBasketDropdownChange($event)"
                    (onVisibleChange)="onSourcingDropdownVisible($event)">
          @for (item of basketIdListView; track $index) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setDropdownAriaLabel(item, 'Basket Name')"
              (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
          }
        </ap-dropdown>
      </div>
    </div>
}

    @if (acctType == '7' || acctType == '8') {
<div>
      <div class="field-label">
        <span>Apportionment Base</span>
      </div>
      <div class="SourcingDropdown">
        <ap-dropdown class="field-full-width" [list]="baseIdListView" [selectType]="'single'"
                    [title]="'Apportionment Base'" [hideTitleOnInput]="true" [inputAriaLabel]="'Apportionment Base'"
                    [(ngModel)]="selectedBaseItem"
                    (onSelect)="onBaseDropdownChange($event)"
                    (onVisibleChange)="onSourcingDropdownVisible($event)">
          @for (item of baseIdListView; track $index) {
            <ap-dropdown-list-item #dropdownListItem [item]="item"
              [ariaLabel]="setDropdownAriaLabel(item, 'Apportionment Base')"
              (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
          }
        </ap-dropdown>
      </div>
    </div>
}

    @if (CheckBasketFlag) {
<div>
      @if (acctType == '7' || acctType == '8') {
<span class="noRecord">
        Please select an Apportionment Base
      </span>
}
      @if (acctType == '5' || acctType == '6') {
<span class="noRecord">
        Please select a Basket
      </span>
}
    </div>
}

    <div class="button-row">
      <ap-button [btnType]="'primary'" [label]="'Save'" class="ap-mr-spacing-3" (onClick)="saveData()"></ap-button>
      <ap-button [btnType]="'primary'" [label]="'Reset'" class="ap-mr-spacing-3" (onClick)="resetData()"></ap-button>
      <ap-button [btnType]="'primary'" [label]="'Cancel'" class="ap-mr-spacing-3" (onClick)="modalClose()"></ap-button>
    </div>

  </div>
</div>
}
